module.exports = __webpack_public_path__ + "img/arrow-red.c13601f7.svg";